module.exports = __webpack_public_path__ + "static/media/soft skills.51f48af0.png";